import { websocketBus } from "@features/use-socket";
import { useCallback, useEffect } from "react";
import { useQueryClient } from "react-query";

export const useImagesWebsockets = () => {
  const queryClient = useQueryClient();

  const handleImageUpdated = useCallback(
    (event: any) => {
      const { data } = event;
      if (!data || !data.id) return;
      queryClient.refetchQueries(["images", data.id]);
    },
    [queryClient]
  );

  useEffect(() => {
    websocketBus.on("images", handleImageUpdated);
    return () => {
      websocketBus.detach("images", handleImageUpdated);
    };
  }, [handleImageUpdated]);
};
